import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Col, DatePicker, Form, Row, Tabs } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import {
  getPayFileDetailByPfid,
  Payfiledetail,
} from 'services/PaymentServices';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import Value from 'components/Value';
// import PFileSelectInput from 'components/PFileSelectInput';
import UtinaCard from 'components/UtinaCard';
import { toCurrency } from 'utils/utils';
import ParListSelect from 'components/ParListSelect';
import { dateToString } from 'utils/utils2';
import moment from 'moment';

const { TabPane } = Tabs;
const PFileDetail = () => {
  let { pfid } = useParams<{ pfid: string }>();
  const initialSearchParams: any = {
    paydocdate: '',
    payduedate: '',
    paystatus: '',
    pfdid: '' as any,
    pfid: Number(pfid),
    tpname: '',
  };
  const [searchParams, setSearchParams] = useState<any>(initialSearchParams);

  const [PFileDetailList, setPFileDetailList] = useState<any[]>();

  const { data, refetch, isFetching } = useQuery(
    ['getPayFileDetailByPfid', searchParams],
    () =>
      getPayFileDetailByPfid(searchParams).then((res) => {
        setPFileDetailList(res.list);
        return res.data;
      }),
    { enabled: !!pfid }
  );

  const [form] = useForm();

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);

      if (data) {
        form.setFieldsValue({
          creationdate: form.getFieldValue('creationdate').substring(0, 10),
          pftotalamount:form.getFieldValue('pftotalamount') +'  '+form.getFieldValue('currcode')
        });
      }
    }
  }, [data, form]);

  const columns = useMemo<DataGridColDef<Payfiledetail>[]>(
    () => [
      {
        dataIndex: 'pfdid',
        width: 80,
        principal: true,
        filtrable: true,
      },
      {
        dataIndex: 'tpname',
        width: 170,
        principal: true,
        filtrable: true,
      },
      {
        dataIndex: 'tpbankname',
        width: 240,
        principal: true,
      },

      {
        dataIndex: 'tpiban',
        width: 170,
      },

      {
        dataIndex: 'payamount',
        render: (val, record) =>
          toCurrency(val, form.getFieldValue('currcode')),
        width: 120,
      },

      {
        dataIndex: 'bkcode',
        width: 120,
      },
      {
        dataIndex: 'bkbranchcode',
        width: 120,
      },
      {
        dataIndex: 'payduedate',
        width: 120,
        filtrable: true,
        filterComponent: <DatePicker />,
        render: (value, record) =>
          dateToString(record.payduedate).substring(0, 10),
      },
      {
        dataIndex: 'paydocdate',
        filtrable: true,
        filterComponent: <DatePicker />,
        render: (value, record) =>
          dateToString(record.paydocdate).substring(0, 10),
        width: 120,
      },
      {
        dataIndex: 'paystatuslabel',
        filtrable: 'paystatus',
        filterComponent: <ParListSelect parcode="PAYMSTATUS" />,
        width: 120,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refetch]
  );

  return (
    <DF.Provider pagcode="PFileDetail">
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        labelAlign="left"
      >
        <div className="card-container">
          <Tabs animated defaultActiveKey="1" type="card">
            <TabPane tab={<GetLabel label="PFileDetail" />} key="1">
              <Row gutter={40}>
                <UtinaCard
                  level={5}
                  comcode="PFileDetail"
                  style={{ color: '#000', marginLeft: 30 }}
                  lg={23}
                >
                  <Row gutter={18}>&nbsp;</Row>
                  <Row gutter={20}>
                    <Col xs={24} lg={24}>
                      <Row gutter={30} style={{ textAlign: 'left' }}>
                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="pfid">
                            <Value />
                          </FormInput>
                        </Col>

                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="paymodelabel">
                            <Value />
                          </FormInput>
                        </Col>
                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="payfiletype">
                            <Value />
                          </FormInput>
                        </Col>
                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="pftotalamount">
                          <Value />
                          </FormInput>
                          
                        </Col>
                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="paydirection">
                            <Value />
                          </FormInput>
                        </Col>
                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="jobid">
                            <Value />
                          </FormInput>
                        </Col>
                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="duedate">
                            <Value />
                          </FormInput>
                        </Col>

                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="creationdate">
                            <Value />
                          </FormInput>
                        </Col>

                        <Col style={{ marginBottom: '30px' }} lg={6} xs={12}>
                          <FormInput name="pfstatuslabel">
                            <Value />
                          </FormInput>
                          {/* 
                          <PFileSelectInput /> */}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </UtinaCard>
              </Row>

              <Row gutter={16}></Row>
            </TabPane>

            <TabPane tab={<GetLabel label="PFileDetailList" />} key="2">
              <DataGrid
                rowKey="payid"
                dataSource={PFileDetailList || []}
                titleComcode="paymentslist"
                columns={columns}
                // extraActions={<Button type="primary" comcode="header.btnnew" />}
                onSearch={(value) => {
                  setSearchParams({
                    ...value,
                    pfid: Number(pfid),
                    payduedate: value.payduedate
                      ? moment(value.payduedate).format('YYYY-MM-DD')
                      : '',
                    paydocdate: value.paydocdate
                      ? moment(value.paydocdate).format('YYYY-MM-DD')
                      : '',
                  });
                }}
                initialSearchValues={initialSearchParams}
                isLoading={isFetching}
              />
            </TabPane>
          </Tabs>
        </div>
      </Form>
    </DF.Provider>
  );
};

export default PFileDetail;
